// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mQC2","newExpiryDate":"styles_newExpiryDate__2zDVI","footer":"styles_footer__3KHIq"};